import CORPORATE_CONFIG from "@/configs/corporate_config.json";
import { clone } from "lodash";

const TAX_STEPS = CORPORATE_CONFIG.TAX_STEPS;
const SME_MAX_CAP = CORPORATE_CONFIG.SME_MAX_CAP;
const OVER_SME_TAX_RATE = CORPORATE_CONFIG.OVER_SME_TAX_RATE;

export function calculateCorporateTaxInfo({ incomes }) {
  let totalIncome = 0;
  let totalExpense = 0;
  if (incomes.onlineSelling) {
    totalIncome = totalIncome + incomes.onlineSelling.income;
    totalExpense = totalExpense + incomes.onlineSelling.expense;
  }
  // if (incomes.salary) {
  //   totalIncome = totalIncome + incomes.salary.income;
  //   totalExpense = totalExpense + incomes.salary.expense;
  // }
  let incomeBeforeTax = Math.max(0, totalIncome - totalExpense);
  let tax = 0;
  let maxTaxRate = 0;

  const taxSteps = clone(TAX_STEPS);

  if (totalIncome < SME_MAX_CAP) {
    taxSteps.reverse().forEach(({ rate, minIncome }) => {
      const overIncome = Math.max(0, incomeBeforeTax - minIncome);
      if (overIncome > 0) {
        maxTaxRate = Math.max(rate, maxTaxRate);
      }
      tax = tax + overIncome * rate;
    });
  } else {
    tax = 0;
    maxTaxRate = OVER_SME_TAX_RATE;
    tax = tax + incomeBeforeTax * OVER_SME_TAX_RATE;
  }
  return {
    totalIncome,
    totalExpense,
    tax,
    maxTaxRate,
  };
}
